module.exports = __webpack_public_path__ + "static/media/netflix.d902c772.jpg";